import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { useForm, Controller } from "react-hook-form";
import { login } from "auth";
import fetcher from "common/utils/fetcher";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import AssetImage from "common/components/AssetImage";
import AzureSSOIcon from "../../assets/sso/azure.png";
import useState from "common/hooks/useState";
import { useSearchParams } from "react-router-dom";
import { MiniLoader } from "common/components/Loader";
import "../../theme/login.css";
import Logo from "../../assets/icon.svg";

export default function LoginPage() {
  const { type, error, loading: SSOLoading } = useState(
    "/api/settings/sso/option"
  );
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = React.useState(false);

  const navigate = useNavigate();
  const { handleSubmit, control } = useForm({
    defaultValues: {
      username: "",
      password: "",
    },
  });
  React.useEffect(() => {
    let error = searchParams.get("error");
    if (error) {
      return toast.error(error);
    }
    let jwt = searchParams.get("jwt");
    if (jwt) {
      setLoading(true);
      //login user
      setTimeout(() => {
        login({ access_token: jwt });
        setLoading(false);
      }, 1000);
    }
  }, [searchParams]);
  const submitHandler = ({ username, password }) => {
    setLoading(true);
    let opts = {
      username,
      password,
    };
    fetcher("/api/login", {
      method: "post",
      body: JSON.stringify(opts),
    })
      .then((token) => {
        if (token.access_token) {
          login(token);
          // if (outside) {
          //   navigate("/");
          // }
          setTimeout(() => {
            setLoading(false);
          }, 100);
        } else {
          setLoading(false);
        }
      })
      .catch((e) => {
        toast.error("Failed Login Attempt");
        setLoading(false);
      });
  };
  const handleEntra = () => {
    window.location.href = `${window.location.protocol}//${window.location.host}/api/sso/entra`;
  };
  const isLoading = SSOLoading || loading;
  return (
    <Container
      sx={{
        height: "100vh",
        backgroundImage: "url(/static/login-background.jpg)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center center",
        width: "100vw !important",
        maxWidth: "100vw !important",
        overflow: "hidden",
        transformOrigin: "top",
      }}
      component="main"
    >
      <CssBaseline />
      <Stack
        sx={{ height: "100%" }}
        alignItems="center"
        justifyContent="center"
      >
        <div className="inherited-styles-for-exported-element div-purle-box">
          <div
            className="div-animate-on-load-04-100width"
            style={{
              transform:
                "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
              transformStyle: "preserve-3d",
              opacity: 1,
            }}
          >
            <div className="div-contact-form-holder">
              <div className="div-contact-form-block-w-form">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "0 0 20px",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "20px",
                  }}
                >
                  <AssetImage
                    skeletonProps={{ width: "150px", height: "150px" }}
                    style={{ width: "150px" }}
                    path="/api/settings/brand/logo"
                    fallback={() => (
                      <>
                        <img
                          src={Logo}
                          style={{ width: "130px", height: "130px" }}
                          alt="logo"
                        />
                        <Typography
                          sx={{
                            fontSize: "35px",
                            fontFamily:
                              '"ECHELONONE", "Helvetica", "Arial", sans-serif',
                            color: "#fff",
                          }}
                          variant="h3"
                          noWrap
                          component="div"
                        >
                          <span
                            style={{
                              fontWeight: "bold",
                            }}
                          >
                            ECHELON
                          </span>
                          <span>ONE</span>
                        </Typography>
                      </>
                    )}
                  />
                </div>
                <form
                  onSubmit={handleSubmit(submitHandler)}
                  name="login-form"
                  data-name="Login Form"
                  method="get"
                  className="form-email-form-contact-us-form"
                  data-wf-page-id="67e82a04d30872582fbfa351"
                  data-wf-element-id="4f683688-df60-2ab2-4e23-e2aa2d967711"
                  aria-label="Login Form"
                >
                  <div className="div-form-fields-holder">
                    <Controller
                      name="username"
                      control={control}
                      render={({ field }) => (
                        <input
                          className="input-Email-2-text-field-w-input"
                          maxLength={256}
                          name="Username"
                          data-name="Username"
                          autoFocus
                          placeholder="Your Username"
                          required
                          {...field}
                        />
                      )}
                    />

                    <Controller
                      name="password"
                      control={control}
                      render={({ field }) => (
                        <input
                          className="input-Name-3-text-field-w-input"
                          maxLength={256}
                          name="Password"
                          data-name="Password"
                          placeholder="Your Password"
                          type="password"
                          required
                          {...field}
                        />
                      )}
                    />
                  </div>
                  {!isLoading && !loading ? (
                    <input
                      type="submit"
                      data-wait="Please wait..."
                      className="input-button-button-glow-w-button"
                      value="LOGIN"
                    />
                  ) : (
                    <div className="input-button-button-glow-w-button">
                      <MiniLoader
                        sx={{ position: "relative", inset: 0, top: "10px" }}
                      />
                    </div>
                  )}
                </form>
              </div>
              {type ? (
                <div className="div-contact-more-info">
                  <div
                    onClick={handleEntra}
                    className="div-contact-info-unique-1"
                  >
                    <img
                      height="40px"
                      width="40px"
                      src={AzureSSOIcon}
                      alt="logo"
                    />
                    <div className="div-contact-info-text">
                      Login with Azure Entra
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </Stack>
    </Container>
  );
}
